import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderCount = 0;
  private _displayLoader = new Subject<boolean>();
  displayLoader$ = this._displayLoader.asObservable();

  constructor() { }

  increaseLoaderCount() {
    if (this.loaderCount === 0) {
      this.loaderCount++;
      this._displayLoader.next(true);
    } else {
      this.loaderCount++;
    }
  }

  decreaseLoaderCount() {
    if (this.loaderCount === 1) {
      this.loaderCount--;
      this._displayLoader.next(false);
    }
    if (this.loaderCount > 1) {
      this.loaderCount--;
    }
  }

  resetCount() {
    if (this.loaderCount > 0) {
      this.loaderCount = 0;
      this._displayLoader.next(false);
    }
  }

  isLoading(): boolean {
    return this.loaderCount > 0;
  }

}
